export default {
  translatedCalibrationHomepageMessage: state => state.translatedCalibrationHomepageMessage
}



// WEBPACK FOOTER //
// ./src/store/modules/notificationmessage/getters.js